/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { AtsIntegrationCto } from '../models/ats-integration-cto';
import { CompanyIntegrationSummaryCto } from '../models/company-integration-summary-cto';
import { getSummary$Json } from '../fn/company-integration/get-summary-json';
import { GetSummary$Json$Params } from '../fn/company-integration/get-summary-json';
import { getSummary$Plain } from '../fn/company-integration/get-summary-plain';
import { GetSummary$Plain$Params } from '../fn/company-integration/get-summary-plain';
import { setAtsIntegrationStatus$Json } from '../fn/company-integration/set-ats-integration-status-json';
import { SetAtsIntegrationStatus$Json$Params } from '../fn/company-integration/set-ats-integration-status-json';
import { setAtsIntegrationStatus$Plain } from '../fn/company-integration/set-ats-integration-status-plain';
import { SetAtsIntegrationStatus$Plain$Params } from '../fn/company-integration/set-ats-integration-status-plain';

@Injectable({ providedIn: 'root' })
export class CompanyIntegrationService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getSummary()` */
  static readonly GetSummaryPath = '/integrations/companies/{companyGuid}/summary';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSummary$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSummary$Plain$Response(params: GetSummary$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<CompanyIntegrationSummaryCto>> {
    return getSummary$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSummary$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSummary$Plain(params: GetSummary$Plain$Params, context?: HttpContext): Observable<CompanyIntegrationSummaryCto> {
    return this.getSummary$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<CompanyIntegrationSummaryCto>): CompanyIntegrationSummaryCto => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSummary$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSummary$Json$Response(params: GetSummary$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<CompanyIntegrationSummaryCto>> {
    return getSummary$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSummary$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSummary$Json(params: GetSummary$Json$Params, context?: HttpContext): Observable<CompanyIntegrationSummaryCto> {
    return this.getSummary$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<CompanyIntegrationSummaryCto>): CompanyIntegrationSummaryCto => r.body)
    );
  }

  /** Path part for operation `setAtsIntegrationStatus()` */
  static readonly SetAtsIntegrationStatusPath = '/integrations/companies/{companyGuid}/ats-integration/status';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `setAtsIntegrationStatus$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  setAtsIntegrationStatus$Plain$Response(params: SetAtsIntegrationStatus$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<AtsIntegrationCto>> {
    return setAtsIntegrationStatus$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `setAtsIntegrationStatus$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  setAtsIntegrationStatus$Plain(params: SetAtsIntegrationStatus$Plain$Params, context?: HttpContext): Observable<AtsIntegrationCto> {
    return this.setAtsIntegrationStatus$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<AtsIntegrationCto>): AtsIntegrationCto => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `setAtsIntegrationStatus$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  setAtsIntegrationStatus$Json$Response(params: SetAtsIntegrationStatus$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<AtsIntegrationCto>> {
    return setAtsIntegrationStatus$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `setAtsIntegrationStatus$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  setAtsIntegrationStatus$Json(params: SetAtsIntegrationStatus$Json$Params, context?: HttpContext): Observable<AtsIntegrationCto> {
    return this.setAtsIntegrationStatus$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<AtsIntegrationCto>): AtsIntegrationCto => r.body)
    );
  }

}
